import { useState, useEffect, useRef, Fragment, memo, useMemo, useContext } from "react";
import style from "./../index.module.scss";
import styleUi from "./PhotoPreview.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import * as YStyled from "../../Styleds";
import FriendInfo from "../../comm/global/components/FriendInfo";
import LogItem from "../../comm/global/components/LogItem";
import apiManager from '../../ApiManager';
import { GameContext } from "../../GameContext";
const PhotoPreview = ({ setModalType, arg, addModalType }) => {
    const { preProcessEvent,events_me_past } = useContext(GameContext);
    const [inProp, setInProp] = useState(false);
    const [starCount, set_starCount] = useState(0);
    const [events, set_events] = useState([]);
    useEffect(() => {
        setInProp(true);
        reload();
        /* apiManager.fetchGet(`collaborative-log/671e6d264fe7b83f4a50ffdf/album-link`, { }, 0).then(res => {
            console.log("res", res)
        }); */
    }, [])
    function reload(){
        apiManager.fetchGet("my/event", { past: true, has_polaroid: false }, 0).then(res => {
            const processEvents = async () => {
                const __events = await Promise.all(res.map(async (event) => {
                    return await preProcessEvent(event);
                }));
                set_events(__events);
               
            };
            processEvents();
        });
    }
    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "PhotoPreview"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app}>
                                <div className={styleUi.headerBar}>
                                    <IconButton onClick={e => {
                                        setInProp(false)
                                    }}>
                                        <ArrowBackIosNewIcon />
                                    </IconButton>
                                </div>
                                <div className={styleUi.view}>
                                    <YStyled.Row style={{ alignContent: "center" }}>
                                        <YStyled.Span size={17} style={{}}>新增照片回顧</YStyled.Span>
                                        {/* <YStyled.BTN5 style={{background:"black",padding:".4rem .8rem"}} onClick={e=>{
                                        addModalType({cls:"PayStar"});
                                    }}>
                                        <img src="./assets/ui/AddStar.png" style={{width:"1.5rem"}} />
                                            <YStyled.Span size={17} fontWeight={400} fontFamily="SF Pro" style={{color:"white"}} onClick={e => {
                                            }}>{starCount}</YStyled.Span>
                                        </YStyled.BTN5> */}
                                    </YStyled.Row>
                                    <div className={styleUi.list}>
                                        {events.map((v, k) => {
                                            return <LogItem key={k} title={v.events_name} date={v.events_date.formatYYYYMMDD2()} point={v.rewildingObj?.rewilding_name} peoples={v.events_participants.latest_tree_user} type="addPhoto" cb={e => {
                                                addModalType({ cls: "NewPhoto" ,arg:{eventId:v.events_id,cb:()=>{
                                                    console.log("cb");
                                                    reload();
                                                }}})
                                                /*  addModalType({
                                                     cls: "AlertCustom", arg: {
                                                       type: 2,
                                                       title: "沒星星了，確定要繼續上傳嗎？",
                                                       desc1: `若你上傳了新的回顧內容，在擁有更多星星前，`,
                                                       desc2: "最古老的星星將暫時無法查看。",
                                                       options: [
                                                         {
                                                           label: "繼續上傳", color: "black", cb: () => {
                                                             addModalType({ cls: "NewPhoto" })
                                                           }
                                                         },
                                                         {
                                                             label: "取消", color: "white", cb: () => {
                                                                 
                                                             }
                                                           }
                                                       ],
                                                     }
                                                   }) */
                                            }} />
                                        })}
                                        <YStyled.BTN2 style={{ background: "black", width: "100%" }} onClick={e => {
                                            addModalType({
                                                cls: "NewEvent", arg: {
                                                    type:"previous",
                                                    cb: () => {
                                                    }
                                                }
                                            })
                                        }}>
                                            <YStyled.Span size={17} fontWeight={400} fontFamily="SF Pro" style={{ color: "white" }} onClick={e => {
                                            }}>新增其他行程</YStyled.Span>
                                        </YStyled.BTN2>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(PhotoPreview);